import { COLUMN_DEFINITIONS as payoutColumnDefs } from "./payout.table.config";
import { COLUMN_DEFINITIONS as jobColumnDefs } from "./job.table.config";
import { COLUMN_DEFINITIONS as invoiceColumnDefs } from "./invoice.table.config";
import { COLUMN_DEFINITIONS as manifestColumnDefs } from "./manifest.table.config";

// Add default configuration
const defaultConfig = {
  COLUMN_DEFINITIONS: [],
};

export const getTableConfig = (modelName) => {
  if (!modelName) return { tableConfig: defaultConfig };

  try {
    const configs = {
      Payout: {
        COLUMN_DEFINITIONS: payoutColumnDefs || [],
      },
      Payouts: {
        COLUMN_DEFINITIONS: payoutColumnDefs || [],
      },
      Job: {
        COLUMN_DEFINITIONS: jobColumnDefs || [],
      },
      Jobs: {
        COLUMN_DEFINITIONS: jobColumnDefs || [],
      },
      Invoice: {
        COLUMN_DEFINITIONS: invoiceColumnDefs || [],
      },
      Invoices: {
        COLUMN_DEFINITIONS: invoiceColumnDefs || [],
      },
      Manifest: {
        COLUMN_DEFINITIONS: manifestColumnDefs || [],
      },
      Manifests: {
        COLUMN_DEFINITIONS: manifestColumnDefs || [],
      },
    };

    return {
      tableConfig: configs[modelName] || defaultConfig,
    };
  } catch (error) {
    console.error("Error in getTableConfig:", error);
    return { tableConfig: defaultConfig };
  }
};

// Make sure we're exporting correctly
export default getTableConfig;










